import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfig } from 'sigv-library';
import { isNullOrEmpty } from 'sigv-library/util';

@Injectable()
export class HttpErrorInterceptorWebsubmission implements HttpInterceptor {
  constructor(
    private router: Router,

  ) {}

  // 進件的interceptor只處理400的CustomError，其他error一律把error response丟出去
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response) => {
        switch (response.status) {
          case 400:
            const errorCode = response.headers.get('X-Error-Code');
            if (isNullOrEmpty(errorCode) === false && errorCode === 'TRNS.TodoWorkStatusInvalid') {
              this.router.navigate(['/']);
              return EMPTY;
            }
            break;
          case 404:
            if (response.url.indexOf(AppConfig.envConfig.iconSrcUrl) >= 0) {
              return of(new HttpResponse(...response));
            }
            break;
          default:
            break;
        }
        return throwError(response);
      })
    );
  }
}
